import {FooterStore, HeaderStore, LocalizationStore, LoginStore, SubscriptionStore} from './stores';

import {EpicGamesNavWrapper} from './components';
import Footer from './components/footer/Footer';
import Helmet from 'react-helmet';
import PropTypes from 'prop-types';
import React from 'react';
import SubscriptionActions from './actions/SubscriptionActions';
// import qs from 'qs';
import classNames from 'classnames';
import {connectToStores} from 'epic-alt-utils/index';
import {getMetaTags} from './utils/Utils';
import getRoutes from './routes/routes';
import {withRouter, matchPath} from 'react-router';
import {getPath} from 'epic-common';

@connectToStores
class App extends React.Component {
    static propTypes = {
        location: PropTypes.object,
        localizationStore: PropTypes.object,
        loginStore: PropTypes.object,
        headerStore: PropTypes.object,
        footerStore: PropTypes.object,
        subscriptionStore: PropTypes.object,
        mobile: PropTypes.bool,
        tablet: PropTypes.bool,
        msie: PropTypes.bool,
        firefox: PropTypes.bool
    };

    static getStores() {
        return [LocalizationStore, HeaderStore, FooterStore, LoginStore];
    }

    static getPropsFromStores() {
        return {
            localizationStore: LocalizationStore.getState(),
            subscriptionStore: SubscriptionStore.getState(),
            footerStore: FooterStore.getState(),
            headerStore: HeaderStore.getState(),
            loginStore: LoginStore.getState(),
            mobile: HeaderStore.getState().mobile(),
            tablet: HeaderStore.getState().tablet(),
            msie: HeaderStore.getState().msie(),
            firefox: HeaderStore.getState().firefox()
        };
    }

    static getInitialActions() {
        return [
            (props) => {
                const {loginStore} = props;
                if (loginStore.isLoggedIn && loginStore.accountInfo) {
                    const {email} = loginStore.accountInfo;
                    SubscriptionActions.getStatus(email);
                }
            }
        ];
    }

    showHeaderAndFooter = () => {
        const noHeaderPages = ['download-now', 'download-now-thankyou'];
        const path = getPath();
        const {location} = this.props;
        const patterns = [`${path}:locale/:slug`, `${path}:locale/:slug/success`];
        for (let i = 0; i < patterns.length; i += 1) {
            const match = matchPath(location.pathname, {
                path: patterns[i],
                exact: true,
                strict: false
            });

            if (match && match.params.slug) {
                const activeSlug = match.params.slug;
                if (noHeaderPages.indexOf(activeSlug) !== -1) {
                    return false;
                }
            }
        }
        return true;
    }

    render() {
        const classes = classNames('spyjinx-wrapper', {
            mobile: this.props.mobile,
            tablet: this.props.tablet,
            msie: this.props.msie,
            firefox: this.props.firefox
        });
        const routes = getRoutes();
        const tags = getMetaTags(this.props.localizationStore);
        const showHeaderFooter = this.showHeaderAndFooter();
        return (
            <div>
                <Helmet
                    meta={tags}
                    title={this.props.localizationStore.message('epic.spyjinx.name')} />
                {showHeaderFooter && <EpicGamesNavWrapper {...this.props} />}
                <div className={classes}>
                    {routes}
                </div>
                {showHeaderFooter && <Footer
                    loginStore={this.props.loginStore}
                    footerStore={this.props.footerStore}
                    localizationStore={this.props.localizationStore}
                    />}
            </div>
        );
    }
}

export default withRouter(App);
